import React from 'react';
import './MapView.css';
import InfoBox from './InfoBox';
import MapSvg from './MapSvg';
import ReactTooltip from 'react-tooltip';


class MapView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   	activeStateId: "none",
			infoBoxVisibility: "hidden"

		}
		this.showTooltip = this.showTooltip.bind(this)
		this.hideTooltip = this.hideTooltip.bind(this)
	
	}

	showTooltip(id) {
		let stateInfo = this.props.data.states.o[id];
		this.setState(
			{
				activeStateId: id,
				activeStateInfo: stateInfo,
				infoBoxVisibility: "visible"	
			}
		)
	}
	hideTooltip(id) {
		this.setState(
			{
				activeStateId: "none",
				activeStateInfo: "none",
				infoBoxVisibility: "hidden"
			}
		)
	}
	render() {
		return(
			<div className='mapBox'>
				<MapSvg
					data = 			{this.props.data}
					showTooltip = 	{this.showTooltip}
					hideTooltip = 	{this.hideTooltip}
					show = 				{this.props.show}	

				>
				</MapSvg>					
				<ReactTooltip id='global' aria-haspopup='true' type="dark">
					<InfoBox
						data = 				{this.props.data}
						activeStateId =		{this.state.activeStateId}
						activeStateInfo = 	{this.state.activeStateInfo}
						show = 				{this.props.show}	
					>
					</InfoBox>
				</ReactTooltip>
			</div>				
		)
	}
}

export default MapView
